export const FRAME_ID = 'xv-frame';

/** Returns true if the given string matches the https://subdomain.ingrammicro.com structure.
 * Subdomains and port number are optional, otherwise the string must match exactly. */
export function isValidOrigin(origin: string) {
  const originRegEx =
    /^(https:\/\/)([A-Za-z0-9-]*\.){0,1}(ingrammicro\.com){1}(:{1}[0-9]{0,8}){0,1}$/;
  return originRegEx.test(origin);
}
